import React from "react";
import { useRoutes } from "react-router-dom";
import RTL from "./layouts/full-layout/customizer/RTL";
import { CssBaseline, ThemeProvider } from "@material-ui/core";
import ThemeSettings from "./layouts/full-layout/customizer/settings";
import { useSelector } from "react-redux";
import Themeroutes from "./routes/Router";
import "react-perfect-scrollbar/dist/css/styles.css";
import { Toaster } from "react-hot-toast";
import "./views/authentication/Inputs.scss";

import { AuthProvider, useAuth } from "./utils/contexts";
import Spinner from "./views/spinner/Spinner";

/* 
Pagina principal que carga los datos del usuario,
 configuraciones iniciales y tema de toda la aplicación 
 como realiza el route de cada pagina 
 */

const AppContent = () => {
  const theme = ThemeSettings();
  const customizer = useSelector((state) => state.CustomizerReducer);
  const { isLogged, isUser, isAdmin, isSeller, isAccountant, loading } = useAuth();

  const routing = useRoutes(
    Themeroutes(isLogged, isUser, isAdmin, isSeller, isAccountant)
  );

  if (loading) {
    return <Spinner />;
  }

  return (
    <ThemeProvider theme={theme}>
      <RTL direction={customizer.activeDir}>
        <CssBaseline />
        {routing}
      </RTL>
      <Toaster
        position="top-center"
        reverseOrder={true}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          // Define default options
          className: "",
          duration: 6000,
          style: {
            background: "#021E4C",
            color: "#fff",
          },
          // Default options for specific types
          success: {
            duration: 4000,
            theme: {
              primary: "green",
              secondary: "black",
            },
          },
        }}
      />
    </ThemeProvider>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;

